import InsightsRevenueLeakageListInnerItem from "./insights-revenue-leakage-list-inner-item";

export default InsightsRevenueLeakageListInnerItem;
